import { useTheme } from '@shopify/restyle';
import type { ConcreteSvgIcon, CreateSvgIcon } from '@webstore-monorepo/shared/interfaces';
import type { Theme } from '@webstore-monorepo/shared/theme';
import React, { memo } from 'react';
import Svg, { G, Path } from 'react-native-svg';

export const SvgIcon: React.FC<CreateSvgIcon> = (props: CreateSvgIcon): React.ReactElement => {
  const theme = useTheme<Theme>();
  const { iconConfig, ...restOfProps } = props;
  const width: number = +(restOfProps.viewBox ?? iconConfig.viewBox).split(' ')[2];
  const height: number = +(restOfProps.viewBox ?? iconConfig.viewBox).split(' ')[3];
  // @ts-ignore
  const fill = restOfProps.fill ? theme.colors[restOfProps.fill] : theme.colors.primaryColor;
  // @ts-ignore
  const stroke = restOfProps.stroke ? theme.colors[restOfProps.stroke] : theme.colors.gray;
  return (
    <Svg
      strokeOpacity={restOfProps.strokeOpacity || iconConfig.strokeOpacity || 0}
      strokeWidth={restOfProps.strokeWidth || 1.0}
      width={restOfProps.width || width}
      height={restOfProps.height || height}
      viewBox={restOfProps.viewBox ?? iconConfig.viewBox}
      {...restOfProps}
    >
      <G fill={fill} stroke={stroke} fillOpacity={iconConfig.fillOpacity || props.fillOpacity}>
        {iconConfig.paths.map((path: string) => (
          <Path d={path} key={path} />
        ))}
      </G>
    </Svg>
  );
};

export const createSvgIcon = (config: CreateSvgIcon): React.FC<ConcreteSvgIcon> => {
  const createdIcon = (props: ConcreteSvgIcon) => {
    return <SvgIcon {...config} {...props} />;
  };
  return memo(createdIcon);
};

export const CheckboxIcon = createSvgIcon({
  iconConfig: {
    paths: [
      'M21.2287 6.60355C21.6193 6.99407 21.6193 7.62723 21.2287 8.01776L10.2559 18.9906C9.86788 19.3786 9.23962 19.3814 8.84811 18.9969L2.66257 12.9218C2.26855 12.5349 2.26284 11.9017 2.64983 11.5077L3.35054 10.7942C3.73753 10.4002 4.37067 10.3945 4.7647 10.7815L9.53613 15.4677L19.1074 5.89644C19.4979 5.50592 20.1311 5.50591 20.5216 5.89644L21.2287 6.60355Z',
    ],
    viewBox: '0 0 24 24',
  },
  fill: 'gray',
  strokeWidth: 1,
  stroke: 'gray',
  strokeOpacity: 1,
  width: 16,
  height: 16,
});
